import './Footer.css';
import logo from '../assets/logo.svg';
import arrowIcon from '../assets/arr.svg';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-redesign">
      <div className="footer-redesign__content">
        <div className="footer-redesign__logo">
          <img src={logo} alt="WinningPartner"/>
        </div>
        <div className="footer-redesign__links">
          <a href="#section-testimonials">Testimonials</a>
        </div>
        <div className="footer-redesign__links">
          <a href="/terms">Terms and Conditions</a>
        </div>
        <div className="footer-redesign__links">
          <a href="/privacy">Privacy Policy</a>
        </div>
        <div className="footer-redesign__right">
          <button className="footer-redesign__top" onClick={scrollToTop}>
            Back to Top
            <img src={arrowIcon} alt="" className="footer-redesign__arrow" />
          </button>
          <div className="footer-redesign__copyright">
            © Copyright {new Date().getFullYear()} WinningPartner Network, All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
